export const PENDING_PRACTITIONER_RECEIVED = "PENDING_PRACTITIONER_RECEIVED";
export const PRACTITIONER_LIST_RECEIVED = "PRACTITIONER_LIST_RECEIVED";
export const PRACTITIONER_SEARCH_LIST_RECEIVED =
  "PRACTITIONER_SEARCH_LIST_RECEIVED";
export const PRACTITIONER_LIST_RECEIVED_FOR_ADMIN =
  "PRACTITIONER_LIST_RECEIVED_FOR_ADMIN";
